import React from 'react'
import { connect } from 'react-redux'
import { setLandTrustMapReference } from '../../../action/map-reference-landtrust'
import RenderLayers from '../../recreationAccess/render-layers/renderHuntLayers'

import { degrees2meters } from '../../../lib/util'
import featureData from '../../../lib/api/featureData'
import { fetchFeatureInfoFields } from '../../../action/feature-field-actions'
import isNil from 'lodash/isNil'
import { huntPlannerRightMenuBarOpen, huntPlannerRightMenuBarClose } from '../../../action/huntplanner-menu-bar'

import { startLoading, stopLoading } from '../../../action/huntPlanner-load-spinner-action'
import LayerToggle from '../../map/layer-toggle'
import Loader from '../reusableComponents/loader/Loader'
import { startMapLoading, stopMapLoading } from '../../../action/huntplanner-map-loader'
import { fetchGetUnitDetails } from '../../../action/huntPlanner-unitdetails-actions'
import '../../map/index.scss'
import RenderMarkers from '../renderMarkers/index'
import { landTrustRightMenuBarOpen } from '../../../action/land-trust-menu-bar'
// import Weather from '../map/weather/index'
// import Geolocation from '../map/geoLocation/index'
// import ShareMarker from '../main-ui/left-toolbar/common/share-location'

class LandTrustMap extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      map: null,
      featureData: null,
      loadspinner: false,
      mapWidth: this.calculateMapWidth(props) // Initialize mapWidth
    }
    this.getZoomButtons = this.getZoomButtons.bind(this)
    this.doubleClicked = false
  }

  // Function to calculate mapWidth based on props
  calculateMapWidth = (props) => {
    return props.landTrustMenuBar && !props.lantTrustPrivateLandDetails && !props.landTrustRightMenuBarObj.expanded ?
      'calc(-23.4375vw - 78px + 100vw)' :
      (props.lantTrustPrivateLandDetails || props.landTrustRightMenuBarObj.expanded) ?
        'calc(-46.86vw - 78px + 100vw)' :
        'calc(-23.4375vw - 78px + 100vw)';
  };

  getZoomButtons() {
    const zoomContainer = document.createElement('div');
    const zoomOut = document.createElement('div');
    const zoomIn = document.createElement('div');
    const zoomInIcon = document.createElement('div');
    const zoomOutIcon = document.createElement('div');

    zoomContainer.className = 'map-zoom-container'; // Add a class for the container
    zoomIn.className = 'map-zoom-in';
    zoomOut.className = 'map-zoom-out';
    zoomOutIcon.className = 'map-zoom-out-icon';
    zoomInIcon.className = 'map-zoom-in-icon';

    zoomOut.appendChild(zoomOutIcon);
    zoomIn.appendChild(zoomInIcon);
    zoomContainer.appendChild(zoomOut); // Append zoomOut to the container
    zoomContainer.appendChild(zoomIn); // Append zoomIn to the container


    zoomIn.addEventListener('click', e => {
      e.stopPropagation();
      const zoom = this.state.map.getZoom();
      this.state.map.setZoom(zoom + 1);
    });

    zoomOut.addEventListener('click', e => {
      e.stopPropagation();
      const zoom = this.state.map.getZoom();
      this.state.map.setZoom(zoom - 1);
    });

    return zoomContainer; // Return the container instead of an array
  }
  componentDidMount() {
    this.setState(
      {
        map: new google.maps.Map(this.refs.mapContainer, {
          zoom: 4,
          center: new google.maps.LatLng({ lat: 39.71, lng: -100.21 }),
          fullscreenControl: false,
          clickableIcons: false,
          zoomControl: false,
          scaleControl: true,
          rotateControl: false,
          mapTypeControl: false,
          gestureHandling: 'greedy',
          minZoom: 3,
          mapId: "4504f8b37365c3d0",
          rotateControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          options: {
            styles: [
              {
                featureType: 'all',
                elementType: 'labels',
                stylers: [{ visibility: 'on' }]
              }
            ]
          },
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          restriction: {
            latLngBounds: {
              north: 85,
              south: -85,
              west: -180,
              east: 180
            },
            strictBounds: false
          }
        })
      }, () => {
        // this.props.setMapReference(this.mapReference.bind(this))
        this.props.setLandTrustMapReference(this.mapReference.bind(this))
        setTimeout(() => {
          this.handleUnitPreferenceChange();
        }, 3000);
        const zoomControlsContainer = this.getZoomButtons();
        this.state.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlsContainer);
        this.state.map.addListener('dblclick', () => {
          this.doubleClicked = true
        })
        this.state.map.addListener('click', (e) => {
          console.log('helooooo click on maps', this.state.map.overlayMapTypes)
          const y = e.pixel.y;
          const x = e.pixel.x;

          const mapDivRect = this.state.map.getDiv()

          // Get the height and width of the map container
          const mapHeight = mapDivRect.offsetHeight;
          const mapWidth = mapDivRect.offsetWidth;

          // Define thresholds for the corners (adjust as needed)
          const topThreshold = mapHeight / 3;   // Top third of the map
          const bottomThreshold = mapHeight * 2 / 3;  // Bottom third of the map
          const leftThreshold = mapWidth / 3;   // Left third of the map
          const rightThreshold = mapWidth * 2 / 3;  // Right third of the map

          // console.log(topThreshold, bottomThreshold, y);

          let transformStyle = {};

          if (y < topThreshold) {
            // Top half of the map
            if (x < leftThreshold) {
              // Top-left corner
              console.log('Click is in the top-left corner.');
              transformStyle = { transform: `translate(0%, 0%)` }; // Show modal to the right
            } else if (x > rightThreshold) {
              // Top-right corner
              console.log('Click is in the top-right corner.');
              transformStyle = { transform: `translate(-100%, 0%)` }; // Show modal to the left
            } else {
              // Middle of the top third
              console.log('Click is in the middle top.');
              transformStyle = { transform: `translate(0%, 0%)` }; // Modal above the click position
            }
          } else {
            // Bottom half of the map
            if (x < leftThreshold) {
              // Bottom-left corner
              console.log('Click is in the bottom-left corner.');
              transformStyle = { transform: `translate(-2%, -99%)` }; // Show modal to the right
            } else if (x > rightThreshold) {
              // Bottom-right corner
              console.log('Click is in the bottom-right corner.');
              transformStyle = { transform: `translate(-96%, -100%)` }; // Show modal to the left
            } else {
              // Middle of the bottom third
              console.log('Click is in the middle bottom.');
              transformStyle = { transform: `translate(-2%, -99%)` }; // Modal below the click position
            }
          }

          if (this.props.featuresBlocked) {
            return
          }
          this.doubleClicked = false
          if (this.state.map.overlayMapTypes.length > 0 && this.state.featureData === null) {
            this.setState({ loadspinner: true })
            this.props.startMapLoading()
            const { layersDictionary, token, fetchFeatureInfoFields, featureFields } = this.props,
              mapDivRect = this.state.map.getDiv().getBoundingClientRect(),
              zoom = this.state.map.getZoom(),
              mapBounds = this.state.map.getBounds(),
              SWD = mapBounds.getSouthWest(),
              NED = mapBounds.getNorthEast(),
              SWM = degrees2meters(SWD.lng(), SWD.lat()),
              NEM = degrees2meters(NED.lng(), NED.lat()),
              overlayLayers = [].concat(this.state.map.overlayMapTypes.getArray())
                .filter(layer => layer.alt && layer.alt.from === 'hunt planner') // Filter for 'hunt planner' layers
                .sort((a, b) => b.alt.drawOrder - a.alt.drawOrder),
              featureArr = overlayLayers.map(layer => {
                const layerData = layersDictionary[layer.alt.id],
                  requestUrl = `${layerData.server}` +
                    'wms?service=WMS' +
                    '&request=GetFeatureInfo' +
                    `&layers=${layerData.serverLayerName}` +
                    `&QUERY_LAYERS=${layerData.serverLayerName}` +
                    `&bbox=${SWD.lng()},${SWD.lat()},${NED.lng()},${NED.lat()}` +
                    `&width=${mapDivRect.width}` +
                    `&height=${mapDivRect.height}` +
                    '&srs=EPSG:4326' +
                    '&INFO_FORMAT=application/json' +
                    '&FEATURE_COUNT=50' +
                    `&X=${e.pixel.x}` +
                    `&Y=${e.pixel.y}`
                if (isNil(featureFields[layerData.id])) {
                  fetchFeatureInfoFields(layerData.id)
                }
                return {
                  layer: requestUrl,
                  layerId: layerData.id,
                  returnGeometry: false,
                  returnSeasonDates: true,
                  returnHarvestData: true,
                  returnPublicPhotos: true
                }
              })
            featureData.get(featureArr, zoom, token)
              .then(res => {
                // Check if response has valid data
                if (Array.isArray(res) && res.length > 0 && res[0].features && res[0].features.length > 0) {
                  // Get the clicked location
                  let reslen = res?.[0]?.features.length;
                  const clickedLocation = e.latLng;
                  let payload = {
                    ...this.props.huntPlannerSelectedOtions,
                    unitName: res?.[0]?.features?.[reslen - 1]?.properties?.Unit || ''
                  }
                  // let payload = {
                  //     ...this.props.huntPlannerSelectedOtions,
                  //     unitName: res?.[0]?.features?.[0]?.properties?.Unit || ''
                  // }
                  this.props.fetchGetUnitDetails(payload)
                    ?.then((response) => {
                      if (response != 'Requested unit is not currently visible')
                        setTimeout(() => {
                          // this.props.huntPlannerRightMenuBarClose();
                          this.props.huntPlannerRightMenuBarOpen({ mapData: res, unitDetails: response, expanded: true, coordinates: clickedLocation }); // Updates Redux state
                        }, [1000 * 1])
                      else {
                        this.props.stopMapLoading()
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                    })
                } else {
                  console.error('Invalid or empty features data:', res);
                  this.props.huntMapLoader && this.props.stopMapLoading()
                }

                this.setState({ loadspinner: false })
                if (this.doubleClicked) {
                  return
                }
              })
              .catch(err => {
                console.log('Feature Data Get Failed Map Click', err)
                this.props.huntMapLoader && this.props.stopMapLoading()
              })
          }
          setTimeout(() => {
            this.setState({ loadspinner: false })
          }, [1000 * 10])


        })
      })

    const topValue = this.props.selectedTab != "map" ? '0px' : "-70px"
    // Create or update the style element
    let styleElement = document.getElementById('gm-style');
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'gm-style';
      document.head.appendChild(styleElement);
    }

    // Set the CSS rules dynamically
    styleElement.innerHTML = `
        .gm-svpc {
          left: -45px !important;
          width: 50px !important;
          height: 50px !important;
          border-radius: 50% !important;
          background-color: #1D1D1D !important;
          top: ${topValue} !important;
        }
      `;
  }

  componentDidUpdate(prevProps) {
    const { userPreferences } = this.props;
    let refContainer = this.refs.mapContainer
    // Only perform actions if the units have changed
    if (prevProps.userPreferences.units !== userPreferences.units && refContainer) {
      this.handleUnitPreferenceChange();
    }
    if (
      prevProps.landTrustMenuBar !== this.props.landTrustMenuBar ||
      prevProps.lantTrustPrivateLandDetails !== this.props.lantTrustPrivateLandDetails ||
      prevProps.landTrustRightMenuBarObj.expanded !== this.props.landTrustRightMenuBarObj.expanded
    ) {
      this.setState({ mapWidth: this.calculateMapWidth(this.props) });
    }

    if (prevProps.selectedTab !== this.props.selectedTab) {
      const topValue = this.props.selectedTab == "map" ? '-70px' : "0"
      let styleElement = document.getElementById('gm-style');
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = 'gm-style';
        document.head.appendChild(styleElement);
      }

      // Set the CSS rules dynamically
      styleElement.innerHTML = `
                .gm-svpc {
                  left: -45px !important;
                  width: 50px !important;
                  height: 50px !important;
                  border-radius: 50% !important;
                  background-color: #1D1D1D !important;
                  top: ${topValue} !important;
                }
              `;


    }


  }

  handleUnitPreferenceChange() {
    const { userPreferences } = this.props;
    let refContainer = this.refs.mapContainer
    if (refContainer) {

      const spans = refContainer.getElementsByTagName('span'),
        ptrnI = /\d+\s+(m|km)/i,
        ptrnM = /\d+\s+(ft|mi)/i;

      // Iterate over the spans and trigger clicks based on userPreferences.units
      for (let i = 0; i < spans.length; i++) {
        // If metric units are selected, trigger click for metric values
        if (userPreferences.units === 'metric' && ptrnM.test(spans[i].innerHTML)) {
          spans[i].click();
        }

        // If imperial units are selected, trigger click for imperial values
        if (userPreferences.units === 'imperial' && ptrnI.test(spans[i].innerHTML)) {
          spans[i].click();
        }
      }
    }
  }

  setFeatureData(featureData) {
    this.setState({ featureData })
  }

  clearFeatureData() {
    this.setState({ featureData: null })
  }

  mapReference() {
    return this.state.map
  }

  render() {
    const { leftToolbarState, rightToolbarState, userPreferences, huntPlannerUnitRightMenuBar, huntplannerMorefiltersExpand } = this.props,
      { loadspinner, mapWidth } = this.state,
      // mapWidth = this.props.width ? this.props.width : huntPlannerUnitRightMenuBar.expanded ? 'calc(-23.4375vw - 78px + 100vw)' : huntplannerMorefiltersExpand ? 'calc(-23.4375vw -23.4375vw - 78px + 100vw)' : 'calc(100vw - 78px)',
      // mapWidth = huntPlannerUnitRightMenuBar.expanded ? 'calc(-23.4375vw - 78px + 100vw)' : huntplannerMorefiltersExpand ? 'calc(-23.4375vw -23.4375vw - 78px + 100vw)' : 'calc(100vw - 78px)',
      mapOffset = this.props.left ? this.props.left : '78px',
      mapHeight = this.props.height ? this.props.height : 'calc(100vh - 60px)',
      mapTopset = this.props.top ? this.props.top : '60px',
      refContainer = this.refs.mapContainer
    return (
      <>
        {this.props.huntMapLoader &&
          <div className={`hunt-planner-loading-container`}>
            <Loader
              position={'absolute'}
              left={!this.props.landTrustMenuBar ?
                // && !this.props.landTrustMorefiltersExpand && !this.props.landTrustRightMenuBarObj.expanded ? '35%' : this.props.landTrustMorefiltersExpand && !this.props.landTrustRightMenuBarObj.expanded ? '22%' : this.props.landTrustRightMenuBarObj.expanded ? 
                '22%' : '44%'}
            ></Loader>
          </div>
        }

        <div className="map-container" style={{ height: '100vh' }}>
          <div id="map" ref="mapContainer" style={{
            transition: 'width 0.10s ease',
            left: mapOffset,
            width: mapWidth,
            height: mapHeight,
            top: mapTopset
          }} />
          <RenderLayers />
          <LayerToggle />
          <RenderMarkers />
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  featureFields: state.featureFields,
  token: state.auth.token,
  loading: state.loading,
  huntplannerRightToolbar: state.huntplannerRightToolbar,
  huntplannerMorefiltersExpand: state.huntplannerMorefiltersExpand,
  leftToolbarState: state.leftToolbarState,
  rightToolbarState: state.rightToolbarState,
  layersDictionary: state.layersDictionary,
  userPreferences: state.userPreferences,
  featuresBlocked: state.featuresBlocked,
  mapReference: state.mapReference(),
  huntplannerMorefiltersExpand: state.huntplannerMorefiltersExpand,
  huntMapLoader: state.huntMapLoader,
  huntPlannerUnitRightMenuBar: state.huntPlannerUnitRightMenuBar,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  landTrustMenuBar: state.landTrustMenuBar,
  lantTrustPrivateLandDetails: state.lantTrustPrivateLandDetails,
  landTrustRightMenuBarObj: state.landTrustRightMenuBarObj
})

const mapDispatchToProps = dispatch => ({
  fetchFeatureInfoFields: id => dispatch(fetchFeatureInfoFields(id)),
  // setMapReference: map => dispatch(setMapReference(map)),
  setLandTrustMapReference: map => dispatch(setLandTrustMapReference(map)),
  huntPlannerRightMenuBarOpen: payload => dispatch(huntPlannerRightMenuBarOpen(payload)),
  huntPlannerRightMenuBarClose: () => dispatch(huntPlannerRightMenuBarClose()),
  startLoading: () => dispatch(startLoading()),
  stopLoading: () => dispatch(stopLoading()),
  startMapLoading: () => dispatch(startMapLoading()),
  stopMapLoading: () => dispatch(stopMapLoading()),
  fetchGetUnitDetails: (payload) => dispatch(fetchGetUnitDetails(payload)),
  landTrustRightMenuBarOpen: (payload) => dispatch(landTrustRightMenuBarOpen(payload))

})

export default connect(mapStateToProps, mapDispatchToProps)(LandTrustMap)
